<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle" :type="'empty'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="hr">
          <div class="guideMsg">
            <p class="txtL">
              리뷰를 작성한 스토어를 선택 후
              <br />
              닉네임을 입력해주세요.
            </p>
          </div>

          <div class="formArean">
            <span class="label">1. APP 스토어 선택</span>
            <ul class="reviewEvent">
              <!-- play store 이미지 -->
              <li>
                <a v-show="playOn" @click="storeSelect('playOff')">
                  <img :src="playOnImgPath" class="w75" />
                  <span>play 스토어</span>
                </a>
                <a v-show="playOff" @click="storeSelect('playOn')">
                  <img :src="playOffImgPath" class="w75" />
                  <span>play 스토어</span>
                </a>
              </li>
              <!-- app store 이미지 -->
              <li>
                <a v-show="appOn" @click="storeSelect('appOff')">
                  <img :src="appOnImgPath" class="w75" />
                  <span>App Store</span>
                </a>
                <a v-show="appOff" @click="storeSelect('appOn')">
                  <img :src="appOffImgPath" class="w75" />
                  <span>App Store</span>
                </a>
              </li>
            </ul>

            <span class="label">2. 스토어 닉네임</span>
            <input type="text" id="ipt4" class="ipt" placeholder="리뷰 작성시 사용한 닉네임 입력" value="" v-model="nickName" />

            <!-- 약관 (s) -->
            <div class="termsWrap">
              <div class="inner">
                <ul class="iptGroup">
                  <li>
                    <div class="block">
                      <input type="checkbox" class="ipt" name="terms1" id="terms1_3" v-model="terms" />
                      <label for="terms1_3">
                        <span>[필수]</span>
                        개인정보수집 및 이용약관 동의
                      </label>
                      <button type="button" class="links arrow" @click="popupOpen"><span class="blind">상세약관 전체보기</span></button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <!-- 약관 (e) -->
          </div>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="regist" :disabled="regButtonShow">이벤트 신청하기</button>
          </div>
        </section>
        <MessagePop v-if="messagePopFlag" @close="close">
          <p v-html="msg"></p>
        </MessagePop>

        <template v-if="TermPopupFlag" @close="close" @agree="agree">
          <div class="popWrap nowOpen">
            <div class="popup">
              <div class="popContain">
                <div class="popCont full hasBtn" tabindex="-1" role="dialog">
                  <div class="popHead">
                    <h1 class="titH1">[필수] 개인정보 수집 및 이용 동의</h1>
                  </div>
                  <div class="popBody full">
                    <div class="popInner">
                      <!-- 본문 (s) -->
                      <section class="termsDetail">
                        <span class="txt">
                          전화상담을 위해서는 아래 정보 항목에 대한 동의가 필요합니다. 해당 정보 사용에 대한 동의를 거부할 권리가 있으나, 미 동의 시
                          상담 서비스 이용이 불가능합니다.
                        </span>
                        <!-- table (s) -->
                        <table class="tableY line ac">
                          <tbody>
                            <tr>
                              <td class="th">수집∙이용 항목</td>
                            </tr>
                            <tr>
                              <td>신청인 정보(이름, 휴대폰번호)</td>
                            </tr>
                            <tr>
                              <td class="th">수집∙이용 목적</td>
                            </tr>
                            <tr>
                              <td>웰릭스렌탈(주)의 이벤트 운영/경품배송/행사 안내를 목적으로 개인정보를 수집합니다.</td>
                            </tr>
                            <tr>
                              <td class="th">보유기간</td>
                            </tr>
                            <tr>
                              <td>
                                이용 목적 달성 후 지체 없이 파기.
                                <br />
                                단, 이용 목적 달성 후에는 소비자의 불만 또는 분쟁처리, 법령상 의무 이행을 위하여만 보유.이용됩니다.
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- table (e) -->
                      </section>
                      <!-- 본문 (e) -->
                    </div>
                  </div>

                  <div class="btnArea sticky">
                    <button type="button" class="btn_p" @click="agree">동의</button>
                  </div>

                  <button type="button" class="btnIco_close" @click="close"><span>팝업 닫기</span></button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import MessagePop from '@/components/popup/MessagePop';
import JwtService from '@/common/jwt.service';
import { INPUT_INFO_CHECK, TERM_AGREE_CHECK, SERVICE_COMM_ERROR } from '@/store/message.type.js';
import { isEmpty } from '@/common/common.function';

export default {
  name: 'ReviewEvent',
  components: {
    MessagePop,
  },
  data: function() {
    return {
      headerTitle: '리뷰 이벤트 응모하기',

      nickName: null,
      storeType: 'andriod',
      terms: null,

      messagePopFlag: null,
      msg: null,
      TermPopupFlag: null,
      passValidate: false,
      done: false,

      regButtonShow: true,

      playOn: true,
      playOff: false,
      appOn: false,
      appOff: true,

      playOnImgPath: '',
      playOffImgPath: '',
      appOnImgPath: '',
      appOffImgPath: '',
    };
  },
  watch: {
    nickName() {
      this.checkInput();
    },
    terms() {
      this.checkInput();
    },
    storeType() {
      this.checkInput();
    },
  },
  mounted() {
    ApiService.service('GET', '/common/img/147,148,149,150')
      .then(({ data }) => {
        for (let i = 0; i < data.result.length; i++) {
          let obj = data.result[i];
          if (obj.imgId == 147) {
            // app store on
            this.appOnImgPath = obj.imgPath;
          }
          if (obj.imgId == 148) {
            // app store off
            this.appOffImgPath = obj.imgPath;
          }
          if (obj.imgId == 149) {
            // play store on
            this.playOnImgPath = obj.imgPath;
          }
          if (obj.imgId == 150) {
            // play store off
            this.playOffImgPath = obj.imgPath;
          }
        }
      })
      .catch(({ response }) => {
        console.log(response);
      });
  },
  methods: {
    regist: function() {
      this.passValidate = true;
      if (!this.terms) {
        this.msg = TERM_AGREE_CHECK;
        this.messagePopFlag = true;
        this.passValidate = false;
      }

      if (this.storeType == null || this.storeType == '') {
        this.msg = INPUT_INFO_CHECK;
        this.messagePopFlag = true;
        this.passValidate = false;
      }

      if (this.nickName == null || this.nickName == '') {
        this.msg = INPUT_INFO_CHECK;
        this.messagePopFlag = true;
        this.passValidate = false;
      }

      if (this.passValidate) {
        let param = new Object();
        let request = new Object();

        request.nickName = this.nickName;
        request.storeType = this.storeType;

        param.request = request;
        param.serviceType = 'app';

        ApiService.service('POST', '/event/appReview', param)
          .then(({ data }) => {
            if (data.isSucceed) {
              this.msg = '이벤트 신청이 완료되었습니다.';
              this.messagePopFlag = true;
              this.done = true;
            } else {
              this.passValidate = false;
              if (data.error) {
                this.msg = data.error;
              } else {
                this.msg = SERVICE_COMM_ERROR;
              }

              this.messagePopFlag = true;
            }
          })
          .catch(({ response }) => {
            console.log('error : ' + response);
          });
      }
    },
    registOk: function() {
      this.messagePopFlag = false;
      this.TermPopupFlag = false;

      this.$router.go(-1);
    },
    close: function() {
      this.messagePopFlag = false;
      this.TermPopupFlag = false;
      if (this.done) {
        this.$router.push('/event/detail/99');
      } else if (this.passValidate) {
        this.$router.go(-1);
      }
    },
    agree: function() {
      this.terms = true;
      this.TermPopupFlag = false;
    },
    popupOpen: function() {
      this.TermPopupFlag = true;
    },
    checkInput() {
      if (!isEmpty(this.nickName) && !isEmpty(this.storeType) && this.terms === true) {
        this.regButtonShow = false;
      } else {
        this.regButtonShow = true;
      }
    },
    storeSelect(flag) {
      this.playOn = false;
      this.playOff = false;
      this.appOn = false;
      this.appOff = false;

      if (flag == 'playOn') {
        this.playOn = true;
        this.appOff = true;
        this.storeType = 'andriod';
      } else if (flag == 'playOff') {
        this.playOff = true;
        this.appOff = true;
        this.storeType = '';
      } else if (flag == 'appOn') {
        this.appOn = true;
        this.playOff = true;
        this.storeType = 'ios';
      } else if (flag == 'appOff') {
        this.appOff = true;
        this.playOff = true;
        this.storeType = '';
      }
    },
  },
};
</script>
